/* unplugin-vue-components disabled */import { render } from "./xMenu.vue?vue&type=template&id=5ca216f1"
import script from "./xMenu.vue?vue&type=script&lang=jsx"
export * from "./xMenu.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__